import { IonCard, IonCardContent, IonCol, IonContent, IonPage, IonRow, useIonAlert, useIonToast } from '@ionic/react';
import { useEffect, useState } from 'react';

import LoadingContainer from '../../components/loading/LoadingContainer';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { DataProvider } from '../../library/DataProvider';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import InputItem from '../../components/input/InputItem';
import RadioItem from '../../components/radio/RadioItem';
import { barcodeOutline, maleOutline, manOutline, personOutline, phonePortrait, phonePortraitOutline, readerOutline, textOutline } from 'ionicons/icons';
import { EventRegViewAction, RegisterEventPostAction } from '../../redux/actions/Tour';
import { RouteComponentProps, useHistory } from 'react-router';
import AvatarImage from './register/AvatarImage';
import NationalCardImage from './register/NationalCardImage';
import ActionButton from '../../components/button/ActionButton';

interface Props extends RouteComponentProps<{
    event_id: string
  }> { }

const RegisterEvent: React.FC<Props> = ({ match }, props) => {
    const history = useHistory();
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()

    const { loading, eventRegView } = useAppSelector(state => state.eventRegisterView)
    const { form_loading, resp } = useAppSelector(state => state.eventRegister)
    

    const [data, setData] = useState({
        avatarImage: "",
        nationalCardImage: "",
    });

    const [form1, setForm1] = useState({
        mobile: { value: "", validation: { required: false }, error: "" },
        name: { value: "", validation: { required: true }, error: "" },
        family: { value: "", validation: { required: true }, error: "" },
        father: { value: "", validation: { required: true }, error: "" },
        gender: { value: "", validation: { required: true }, error: "" },
        national_code: { value: "", validation: { required: true, min: 10, max: 10 }, error: "" },
        martial: { value: "", validation: { required: true }, error: "" },
        mobile_emergency: { value: "", validation: { required: true, min: 11, max: 11 }, error: "" },
        telephone_emergency: { value: "", validation: { required: true, min: 11, max: 11 }, error: "" },
        description: { value: "", validation: { required: false }, error: "" },
        avatar: { value: '', validation: { required: true }, error: "" },
        national_card: { value: '', validation: { required: true }, error: "" }
    });

    const [formProvider1] = useState(() => new DataProvider(form1, setForm1));

    const registerHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider1.validation(form1);

        console.log(form1.avatar.value);
        

        if (form1.avatar.value.length == 0) {
            toast({ message: "لطفا تصویر پروفایل خود را ثبت نمایید.", duration: 2000, color: "warning" })
        } else if (form1.national_card.value.length == 0) {
            toast({ message: "لطفا تصویر کارت ملی خود را ثبت نمایید.", duration: 2000, color: "warning" })
        }

        if (formValidation) {
            dispatch(RegisterEventPostAction(match.params.event_id, form1.name.value, form1.family.value, form1.gender.value,
                form1.national_code.value, form1.martial.value, form1.father.value, form1.mobile_emergency.value, form1.telephone_emergency.value,
            form1.description.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    history.goBack();
                    history.goBack();
                    toast({ message: resp.message, duration: 5000, color: "primary" })
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    useEffect(() => {
        dispatch(EventRegViewAction(match.params.event_id));
    }, [dispatch])

    useEffect(() => {
        if (eventRegView != null && !loading) {
            const form1Data = { ...form1 };

            form1Data.mobile.value = eventRegView.mobile!;
            if (eventRegView.name != null) {
                form1Data.name.value = eventRegView.name!;
            }
            if (eventRegView.family != null) {
                form1Data.family.value = eventRegView.family!;
            }
            if (eventRegView.gender != null) {
                form1Data.gender.value = eventRegView.gender!;
            }
            if (eventRegView.martial != null) {
                form1Data.martial.value = eventRegView.martial!;
            }
            if (eventRegView.national_code != null) {
                form1Data.national_code.value = eventRegView.national_code!;
            }

            if (eventRegView.avatar)
                form1Data.avatar.value = eventRegView.avatar_path!;
            if (eventRegView.national_card)
                form1Data.national_card.value = eventRegView.national_card_path!;
            setForm1(form1Data);

            setData({
                avatarImage: eventRegView.avatar_path,
                nationalCardImage: eventRegView.national_card_path,
            })
        }
    }, [loading])

    return <LoadingContainer loading={loading}>
        <IonPage className="request-card">
            <Toolbar title="ثبت نام" hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <IonCard>
                    <IonCardContent>
                        <IonRow>
                            <IonCol>
                                <p>
                                پس از ثبت مشخصات، درخواست شما بررسی و در صورت داشتن شرایط به اطلاع شما خواهیم رساند. شما پس از دریافت تاییدیه تنها 24 ساعت فرصت دارید هزینه را پرداخت نمایید در غیر اینصورت نوبت شما لغو و به نفر بعدی واگذار خواهد شد.
                                </p>
                                <br/>
                                
                                <InputItem name="mobile" type="text" label="تلفن همراه" icon={phonePortraitOutline} ltr readonly provider={formProvider1} />

                                <InputItem name="name" type="text" label="نام" icon={personOutline} maxlength={25} provider={formProvider1}  />

                                <InputItem name="family" type="text" label="نام خانوادگی" icon={personOutline} maxlength={25} provider={formProvider1}  />
                                
                                <InputItem name="father" type="text" label="نام پدر" icon={personOutline} maxlength={25} provider={formProvider1}  />

                                <InputItem name="gender" type="select2" label="جنسیت" icon={maleOutline} provider={formProvider1} >
                                    <RadioItem value="1" label='مرد' isChecked={formProvider1.form.gender.value == "1"}/>
                                    <RadioItem value="2" label='زن' isChecked={formProvider1.form.gender.value == "2"} />
                                </InputItem>

                                <InputItem name="national_code" type="tel" label="کد ملی" icon={barcodeOutline} maxlength={10} ltr spaced provider={formProvider1}  />

                                <InputItem name="martial" type="select2" label="وضعیت تاهل" icon={manOutline} provider={formProvider1} >
                                    <RadioItem value="1" label='مجرد' isChecked={formProvider1.form.martial.value == "1"}/>
                                    <RadioItem value="2" label='متاهل' isChecked={formProvider1.form.martial.value == "2"} />
                                </InputItem>

                                <InputItem name="mobile_emergency" type="tel" label="تلفن همراه اضطراری" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider1}  />

                                <InputItem name="telephone_emergency" type="tel" label="تلفن ثابت اضطراری (با کد استان)" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider1}  />

                                <p>توضیحات تکمیلی <small>(در صورتی که با وسیله شخصی در محل آغاز سفر حاضر می شوید یا اینکه در مسیر به گروه می پیوندید با ذکر جزئیات در کادر زیر بنویسید)</small></p>
                                <InputItem name="description" type="textarea" label="توضیحات" icon={textOutline} maxlength={1000} ltr provider={formProvider1}  />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <AvatarImage form={formProvider1.form} setForm={formProvider1.setForm} defaultImage={data.avatarImage} />
                            </IonCol>
                            <IonCol size='12'>
                                <NationalCardImage form={formProvider1.form} setForm={formProvider1.setForm} defaultImage={data.nationalCardImage} />
                            </IonCol>
                        </IonRow>
                        <ActionButton text="ثبت نام" loading={form_loading} noSubmit click={registerHandler} />
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    </LoadingContainer>;
}

export default RegisterEvent